import axios, { AxiosResponse } from 'axios';
import { FetchRightBarDataWdw } from '../redux/lounges/slice';
import { Lounge } from '../redux/lounges/types';
import { GET_BASE_URL } from '../constants/apiEndpoints';
import { getEmptyRightBarData } from './rightBarFallback';
import { sharedRequest } from './sharedRequest';

export const getRightBarApiWdw = async ({
  sortType,
  currentPage,
}: FetchRightBarDataWdw) => {
  const responseBody = (response: AxiosResponse) => response.data;
  const apiEndpoint = GET_BASE_URL + '/api/v1/rightBarWdw';

  try {
    // The right bar renders in several places per page; share one request.
    const { data } = await sharedRequest('rightBarWdw', 60000, () =>
      axios.get<Lounge[]>(`${apiEndpoint}`).then(responseBody)
    );

    return data;
  } catch (err) {
    return getEmptyRightBarData();
  }
};
